<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button status="primary" v-if="isHavePermission('capAccount:report')" @click="report">上报</Button>
      <Button status="primary" v-if="isHavePermission('capAccount:giveupFund')"
              :style="isHavePermission('capAccount:report')? 'margin-left: 20px':''" @click="giveupFund">弃报
      </Button>
    </div>
    <div class="search-box" style="margin-bottom: 10px;">
      <vxe-input v-model="cfNumber" type="search" placeholder="资金流水号" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="ydNumber" style="margin-left: 10px" type="search" placeholder="电子运单号" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="documentNumber" style="margin-left: 10px" type="search" placeholder="单证号"
                 @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="shippingNoteNumber" style="margin-left: 10px" type="search" placeholder="运单号"
                 @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="carrier" style="margin-left: 10px" type="search" placeholder="实际承运人名称" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="vehicleNumber" style="margin-left: 10px" type="search" placeholder="车牌号"
                 @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="reportUser" style="margin-left: 10px" type="search" placeholder="操作人" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-select v-model="searchFormData.reportTime" style="margin-left: 10px" :options="timeOptions"
                  placeholder="上报时间"
      ></vxe-select>
      <div class="search-filter">
        <vxe-modal
            class="timeModal"
            v-model="open"
            width="460"
            height="400"
            :show-footer="false"
            :showHeader="false"
        >
          <template v-slot>
            <DatePicker
                :open="open"
                confirm
                type="daterange"
                :split-panels="true"
                placeholder
                style="width: 432px"
                @on-change="handleChange"
                @on-clear="handleClear"
                @on-ok="handleOk"
            >
              <span class="date-slot"></span>
            </DatePicker>
          </template>
        </vxe-modal>
      </div>
      <Button type="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 5px">
        搜索
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="reset" style="margin-left: 10px">重置</vxe-button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh" style="margin-left: 10px">刷新</vxe-button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          ref="xTable"
          align="center"
          border="none"
          max-height="600"
          :data="tableData"
          :loading="loading"
          @filter-change="filterChangeMethod"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          @sort-change="sortChangeEvent"
      >

        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column title="操作" width="90">
          <template slot-scope="{ row }">
            <a v-if="row.reportStatus !== 1 && isHavePermission('capAccount:edit')" @click="goUpdate(row.id)">编辑</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="id" title="序号" width="90">
        </vxe-table-column>
        <vxe-table-column field="cfNumber" title="资金流水号" width="140">
          <template slot-scope="{ row }">
            <span @click="showDetail(row.id)" style="color: #2d8cf0; cursor: pointer">{{ row.cfNumber }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="reportStatus" title="上报" width="100"
                          :filters="[{label: '未上报', value: 0}, {label: '成功', value: 1},{label: '失败', value: 2}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span style="color: #F59A23">{{row.reportStatus | reportStatusMap}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ydNumber" title="电子运单号" width="140"></vxe-table-column>
        <vxe-table-column field="documentNumber" title="单证号" width="140"></vxe-table-column>
        <vxe-table-column field="shippingNoteNumber" title="运单号" width="140"></vxe-table-column>
        <vxe-table-column field="carrier" title="实际承运人名称" width="140" show-overflow></vxe-table-column>
        <vxe-table-column field="vehicleNumber" title="车牌号" width="140"></vxe-table-column>
        <vxe-table-column field="totalMonetaryAmount" title="总金额" width="140"></vxe-table-column>
        <vxe-table-column field="monetaryAmount" title="实际支付金额" width="140"></vxe-table-column>
        <vxe-table-column field="recipient" title="收款人" width="140" show-overflow></vxe-table-column>
        <vxe-table-column field="dateTime" title="实际付款时间" width="160"></vxe-table-column>
        <vxe-table-column field="reportTime" title="上报时间" width="160" remote-sort>
          <template slot-scope="{ row }">
            <span>{{ row.reportTime | timeFormat }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="reportUser" title="操作人" width="140"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="detailVisible" title="资金流水详情" width="1200" height="800" resize position="center"
               destroy-on-close>
      <cap-account-detail ref="capAccount" @afterSave="afterSave" :payment_code="payment_code"
                          :bank_code="bank_code"
                          :vehicle_plate_color_code="vehicle_plate_color_code"></cap-account-detail>
    </vxe-modal>
    <vxe-modal v-model="reportVisible" title="数据上报" width="500" height="300" resize position="center"
               destroy-on-close>
      <choose-report ref="reportModal" @close="closeReport" @report="reportFund"></choose-report>
    </vxe-modal>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" position="center">
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from '@/apiProvider';
  import capAccountDetail from "./capAccountDetail";
  import ChooseReport from "@/components/modal/ChooseReport";
  import {hideLoading, showLoading} from "@/utils/util";
  import Message from "@/components/common/Message";
  import {SEARCH_TIME} from "@/filters/time";
  import moment from "moment";
  import getAuthOrization from "@/mixin/getAuthOrization";

  export default {
    name: 'CapAccount',
    components: {capAccountDetail, ChooseReport, Message},
    mixins: [getAuthOrization],
    data() {
      return {
        tableData: [],
        loading: false,
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 50
        },
        records: [],
        detailVisible: false,
        reportStatus: null,
        payment_code: [],
        bank_code: [],
        vehicle_plate_color_code: [],
        reportVisible: false,
        messageVisible: false,
        searchFormData: {
          reportTime: null
        },
        timeOptions: SEARCH_TIME.options,
        cfNumber: null,
        ydNumber: null,
        documentNumber: null,
        shippingNoteNumber: null,
        carrier: null,
        vehicleNumber: null,
        reportUser: null,
        isDesc: null
      }
    },
    watch: {
      "searchFormData.reportTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("reportTime");
        },
      },
    },
    mounted() {
      this.$bus.$on("资金流水", () => {
        this.reset();
        this.getKeyByCode(41200, 'payment_code');
        this.getKeyByCode(41300, 'bank_code');
        this.getKeyByCode(40300, 'vehicle_plate_color_code');
        this.queryFundList();
      });
      this.getKeyByCode(41200, 'payment_code');
      this.getKeyByCode(41300, 'bank_code');
      this.getKeyByCode(40300, 'vehicle_plate_color_code');
      this.queryFundList();
    },
    methods: {
      reset() {
        this.searchFormData = {
          reportTime: null
        };
        this.cfNumber = null;
        this.ydNumber = null;
        this.documentNumber = null;
        this.shippingNoteNumber = null;
        this.carrier = null;
        this.vehicleNumber = null;
        this.reportUser = null;
      },
      search() {
        this.page.currentPage = 1
        this.queryFundList();
      },
      openRangeDate(field) {
        if (this.searchFormData[field] === 1) {
          this.rangeTime = field;
          this.open = true;
        } else {
          this.open = false;
        }
      },
      handleChange(date) {
        this.timeVal = date;
        // this.timeVal = date.map( v => moment(v).valueOf());
        console.log(this.timeVal);
      },
      handleClear() {
      },
      handleOk() {
        this.searchFormData[this.rangeTime] = this.timeVal;
        this.rangeTime = false;
        let that = this;
        setTimeout(() => {
          that.searchVisible = true;
        }, 100);
      },
      report() {
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条数据',
            status: "error",
          });
          return
        }
        this.reportVisible = true;
        this.$nextTick(() => {
          this.$refs.reportModal.queryConfigList();
        });
      },
      closeReport() {
        this.reportVisible = false;
      },
      async giveupFund() {
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条数据',
            status: "error",
          });
          return
        }
        let idList = [];
        records.map(i => {
          idList.push(i.id);
        })
        showLoading();
        let res = await $api.reportData.request('giveupFund', {
          ids: idList,
        });
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('弃报成功');
          this.records = [];
          this.page.currentPage = 1;
          this.queryFundList();
        } else {
          let data = res.data;
          let message = '';
          if (data.length > 0) {
            data.map(i => {
              message = message + i.failMsg + '\n';
            })
          }
          if (message === '') {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        }
      },
      async reportFund(reportCompany) {
        let records = this.records;
        let idList = [];
        records.map(i => {
          idList.push(i.id);
        })
        showLoading();
        let res = await $api.reportData.request('reportFund', {
          ids: idList,
          reportCompany: reportCompany
        });
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('上报成功');
          this.reportVisible = false;
          this.records = [];
          this.queryFundList();
        } else {
          let data = res.data;
          let message = '';
          if (data.length > 0) {
            data.map(i => {
              message = message + i.failMsg + '\n';
            })
          }
          if (message === '') {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        }
      },
      async getKeyByCode(code, key) {
        let res = await $api.dict.get("searchDic", {
          parentcode: code
        });
        if (res.status === 1) {
          let arr = [];
          let data = res.data;
          data.map(i => {
            arr.push({
              label: i.dictText,
              value: i.encoded,
            })
          })
          this[key] = arr;
        } else {
          this.$XModal.message(res.message);
        }
      },
      afterSave() {
        this.detailVisible = false;
        this.queryFundList();
      },
      showDetail(id) {
        this.detailVisible = true;
        this.$nextTick(function () {
          this.$refs.capAccount.showDetail(id);
        })
      },
      goUpdate(id) {
        this.detailVisible = true;
        this.$nextTick(function () {
          this.$refs.capAccount.setUpdate(id);
        })
      },
      closeMessage() {
        this.messageVisible = false;
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
      sortChangeEvent(sort) {
        if (sort.order == null) {
          this.isDesc = null
        } else {
          this.isDesc = sort.order === 'desc' ? 1 : 0
        }
        this.queryFundList();
      },
      filterChangeMethod({column, property, values, datas, filters, $event}) {
        this.page.currentPage = 1;
        if (property === "reportStatus") {
          if (values.length > 0) {
            this.reportStatus = values[0];
          } else {
            this.reportStatus = null;
          }
        }
        this.queryFundList()
      },
      refresh() {
        this.queryFundList();
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.queryFundList();
      },
      strDate(dateString) {
        const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
        return new Date(dateString.replace(pattern, '$1/$2/$3 $4:$5:$6'));
      },
      async queryFundList() {
        let reportTime = this.searchFormData.reportTime;
        let reportTimeBegin = null;
        let reportTimeEnd = null;
        if (reportTime && reportTime.length > 0) {
          reportTimeBegin = moment(reportTime[0]).valueOf(); // 开始时间
          reportTimeEnd = moment(reportTime[1]).valueOf() + 86399999; // 结束时间
        }
        this.loading = true;
        let res = await $api.reportData.post('queryFundList', {
          cfNumber: this.cfNumber,
          ydNumber: this.ydNumber,
          documentNumber: this.documentNumber,
          shippingNoteNumber: this.shippingNoteNumber,
          carrier: this.carrier,
          vehicleNumber: this.vehicleNumber,
          reportUser: this.reportUser,
          reportTimeBegin: reportTimeBegin,
          reportTimeEnd: reportTimeEnd,
          orderBy: 2,
          page: this.page.currentPage,
          rows: this.page.pageSize,
          reportStatus: this.reportStatus,
          isDesc: this.isDesc
        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.tableData = res.data.rows;
          this.tableData.map((i) => {
            if (i.dateTime) {
              let dateTime = this.strDate(i.dateTime);
              i.dateTime = this.$utils.toDateString(new Date(dateTime), "yyyy-MM-dd HH:mm:ss");
            }
            this.records.map((j) => {
              if (i.id === j.id) {
                this.$refs.xTable.setCheckboxRow(i, true);
              }
            });
          });
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
    }
  }
</script>
<style>

</style>